module.exports = __webpack_public_path__ + "static/media/Chek_Class.7247f989.svg";